import dayjs from 'dayjs';

// Method 3 (program-report pipeline, ported from Insights1) needs a
// machine_name + start_time/end_time window instead of shift/date/method -
// this derives that window from the shift list the same way Insights1 does.
export function getStartAndEndTime(startDate, endDate, shifts = []) {
  const startDayjs = dayjs(startDate);
  const endDayjs = dayjs(endDate);

  const formatTimeStr = (t, defaultVal) => {
    if (!t) return defaultVal;
    const parts = String(t).trim().split(':');
    if (parts.length === 2) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:00`;
    if (parts.length === 3) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${parts[2].padStart(2, '0')}`;
    return defaultVal;
  };

  if (Array.isArray(shifts) && shifts.length > 0) {
    const sorted = [...shifts].sort((a, b) => Number(a.shift_no) - Number(b.shift_no));
    const firstShift = sorted[0];
    const lastShift = sorted[sorted.length - 1];

    const startBase = startDayjs.format('YYYY-MM-DD');
    const firstStartDayOffset = Number(firstShift.start_day || 1) - 1;
    const actualStartDate = dayjs(startBase).add(firstStartDayOffset, 'day').format('YYYY-MM-DD');
    const startTimeStr = formatTimeStr(firstShift.start_time, '00:00:00');
    const startTimeMs = new Date(`${actualStartDate}T${startTimeStr}`).getTime();

    const endBase = endDayjs.format('YYYY-MM-DD');
    const lastEndDayOffset = Number(lastShift.end_day || 1) - 1;
    const actualEndDate = dayjs(endBase).add(lastEndDayOffset, 'day').format('YYYY-MM-DD');
    const endTimeStr = formatTimeStr(lastShift.end_time, '23:59:59');
    const endTimeMs = new Date(`${actualEndDate}T${endTimeStr}`).getTime();

    return { startTimeMs, endTimeMs };
  }

  const startTimeMs = startDayjs.startOf('day').valueOf();
  const endTimeMs = endDayjs.endOf('day').valueOf();
  return { startTimeMs, endTimeMs };
}
